import { render, staticRenderFns } from "./Alerting.vue?vue&type=template&id=2f78f936&scoped=true"
import script from "./Alerting.vue?vue&type=script&lang=js"
export * from "./Alerting.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f78f936",
  null
  
)

export default component.exports